'use strict';
import classNames from 'classnames';
import React from 'react';
import {mapPropsStream} from 'recompose';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/last';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {IonKeyboardAttach} from '../../../_libs/reactionic/src/components/ionKeyboardAttach';
import {createDimensionObserver} from '../../../core-utilities/react-utils';
import {ModalView} from './ModalView';


export const StreamedComponent = (props$) => {
  const entered$ = Observable
    .timer(50)
    .mapTo(true)
    .startWith(false)
    .takeUntil(props$.last());

  const {
    handler: setDivRef,
    stream: dimensions$,
  } = createDimensionObserver(props$, {
    height: true,
    width: false,
  });

  const styleState$ = Observable
    .combineLatest(
      props$.distinctUntilChanged(null, ({keyboardHeight}) => keyboardHeight),
      dimensions$,
      (props, dimensions) => ({
        availableHeight: dimensions.availableHeight,
        windowHeight: dimensions.windowHeight,
        keyboardHeight: props.keyboardHeight,
      })
    )
    .map(({availableHeight, windowHeight, keyboardHeight}) => {
      if (!keyboardHeight || !windowHeight || !availableHeight) {
        return {
          className: '',
          style: null,
        };
      } else if (availableHeight >= windowHeight - keyboardHeight) {
        const offset = 0;
        return {
          className: 'Modal_keyboardOpen',
          style: {
            top: `${offset}%`,
            maxHeight: `${windowHeight - keyboardHeight}px`,
          },
        };
      } else {
        const keyboardPercentage = 100 * keyboardHeight / windowHeight;
        const offset = (100 - keyboardPercentage) / 2;
        return {
          className: '',
          style: {
            top: `${offset}%`,
          },
        };
      }
    })
    .takeUntil(props$.last());

  return props$
    .combineLatest(
      styleState$,
      entered$,
      (props, styleState, entered) => ({
        ...props,
        style: styleState.style,
        className: classNames(styleState.className, props.className),
        entered,
        setDivRef,
      }));
};

export const ModalComponent = IonKeyboardAttach(mapPropsStream(StreamedComponent)(ModalView));



// WEBPACK FOOTER //
// ./src/js/components/modals/Modal/ModalComponent.js